/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PatchedResource
 */
export interface PatchedResource {
  /**
   *
   */
  id: number;
}

/**
 * Check if a given object implements the PatchedResource interface.
 */
export function instanceOfPatchedResource(value: object): value is PatchedResource {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function PatchedResourceFromJSON(json: any): PatchedResource {
  return PatchedResourceFromJSONTyped(json, false);
}

export function PatchedResourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedResource {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
  };
}

export function PatchedResourceToJSON(json: any): PatchedResource {
  return PatchedResourceToJSONTyped(json, false);
}

export function PatchedResourceToJSONTyped(
  value?: PatchedResource | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
  };
}
